import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "@/components/pop-ui/pop-toast";
import { Button } from "@/components/ui/button"; // 假设的按钮组件路径
import { cn, formatDateShort } from "@/lib/utils";
import { getCurrentLanguageInClient, getValueFromTranslations } from "@/lib/utils.client";
import type { Exchange } from "./schema"; // RewardItem 用于类型提示

interface ExchangeItemProps {
  exchange: Exchange;
  onExchange: (exchangeId: string) => void;
  onViewDetail: (exchangeId: string) => void;
  className?: string;
  isMemberUser?: boolean;
  hasBirthday?: boolean;
  onLogin?: (action?: {
    type: "birthday" | "exchange";
    exchangeId?: string;
  }) => void;
}
export const ExchangeItem: React.FC<ExchangeItemProps> = t0 => {
  const $ = _c(58);
  const {
    exchange,
    onExchange,
    className,
    onViewDetail,
    isMemberUser,
    hasBirthday,
    onLogin
  } = t0;
  const lang = getCurrentLanguageInClient();
  const {
    t
  } = useTranslation();
  const pointCost = exchange.costRewards.find(_temp);
  const couponVisualImageUrl = getValueFromTranslations(lang, exchange.icon_trans || {}) || null;
  const titleText = getValueFromTranslations(lang, exchange.name_trans || {}) || getValueFromTranslations(lang, exchange.name_trans || {});
  const pointsNeeded = pointCost ? pointCost.quantity : 0;
  const pointsText = t("points_cost_format", {
    defaultValue: `${pointsNeeded} Points`,
    count: pointsNeeded
  });
  let handleExchangeClick;
  let isBirthdayReward;
  let t1;
  if ($[0] !== exchange.endTime || $[1] !== exchange.exchangeGroup || $[2] !== exchange.hasStock || $[3] !== exchange.id || $[4] !== exchange.startTime || $[5] !== hasBirthday || $[6] !== isMemberUser || $[7] !== onExchange || $[8] !== onLogin || $[9] !== t) {
    let t2;
    if ($[13] !== exchange.id || $[14] !== hasBirthday || $[15] !== isMemberUser || $[16] !== onExchange || $[17] !== onLogin || $[18] !== t) {
      t2 = () => {
        if (!isMemberUser) {
          onLogin?.({
            type: "exchange",
            exchangeId: exchange.id
          });
          return;
        }
        if (isBirthdayReward && hasBirthday === false) {
          toast.info(t("user_account.birthday_rewards_hint"));
          return;
        }
        onExchange(exchange.id);
      };
      $[13] = exchange.id;
      $[14] = hasBirthday;
      $[15] = isMemberUser;
      $[16] = onExchange;
      $[17] = onLogin;
      $[18] = t;
      $[19] = t2;
    } else {
      t2 = $[19];
    }
    handleExchangeClick = t2;
    const now = Date.now();
    const startTime = exchange.startTime ? new Date(exchange.startTime).getTime() : null;
    exchange.endTime ? new Date(exchange.endTime).getTime() : 0;
    isBirthdayReward = exchange.exchangeGroup === "birthday-rewards";
    const getButtonState = () => {
      if (!isMemberUser) {
        return {
          type: "exchange",
          text: t("exchange_button_text", "Redeem")
        };
      }
      if (isBirthdayReward && hasBirthday === false) {
        return {
          type: "disabled",
          text: t("exchange_button_text", "Exchange")
        };
      }
      if (startTime !== null && startTime > now) {
        const comingSoonTimeText = formatDateShort(new Date(startTime));
        return {
          type: "coming_soon",
          text: t("exchange_item.coming_soon_time"),
          time: comingSoonTimeText
        };
      }
      if (!exchange.hasStock) {
        return {
          type: "disabled",
          text: t("exchange_item.out_of_stock", "Out of Stock")
        };
      }
      return {
        type: "exchange",
        text: t("exchange_button_text", "Redeem")
      };
    };
    t1 = getButtonState();
    $[0] = exchange.endTime;
    $[1] = exchange.exchangeGroup;
    $[2] = exchange.hasStock;
    $[3] = exchange.id;
    $[4] = exchange.startTime;
    $[5] = hasBirthday;
    $[6] = isMemberUser;
    $[7] = onExchange;
    $[8] = onLogin;
    $[9] = t;
    $[10] = handleExchangeClick;
    $[11] = isBirthdayReward;
    $[12] = t1;
  } else {
    handleExchangeClick = $[10];
    isBirthdayReward = $[11];
    t1 = $[12];
  }
  const buttonState = t1;
  let t2;
  if ($[20] !== buttonState.text || $[21] !== buttonState.time || $[22] !== buttonState.type || $[23] !== handleExchangeClick || $[24] !== hasBirthday || $[25] !== isBirthdayReward) {
    t2 = () => {
      if (buttonState.type === "coming_soon") {
        return <span className={cn("flex flex-col items-center justify-center text-destructive", "text-xs mt-1 md:mt-2")}><span>{buttonState.text}</span><span>{buttonState.time}</span></span>;
      }
      if (buttonState.type === "disabled") {
        const isBirthdayDisabled = isBirthdayReward && hasBirthday === false;
        return <Button disabled={!isBirthdayDisabled} onClick={isBirthdayDisabled ? handleExchangeClick : undefined} className={cn("font-['DINPro-Bold'] font-bold text-[#999] leading-4 text-left not-italic underline uppercase", "mt-5 md:mt-6  text-sm md:text-base leading-none", isBirthdayDisabled ? "cursor-pointer" : "cursor-not-allowed")} variant="link">{buttonState.text}</Button>;
      }
      if (buttonState.type === "exchange") {
        return <Button onClick={handleExchangeClick} className={cn("font-['DINPro-Bold'] font-bold hover:font-bold text-destructive leading-4 text-left not-italic underline uppercase cursor-pointer", "mt-5 md:mt-6   text-sm md:text-base  leading-none")} variant="link">{buttonState.text}</Button>;
      }
      return null;
    };
    $[20] = buttonState.text;
    $[21] = buttonState.time;
    $[22] = buttonState.type;
    $[23] = handleExchangeClick;
    $[24] = hasBirthday;
    $[25] = isBirthdayReward;
    $[26] = t2;
  } else {
    t2 = $[26];
  }
  const renderExchangeButton = t2;
  let t3;
  if ($[27] !== className) {
    t3 = cn("flex flex-col items-center justify-start border border-[#eee]", "pb-3 md:pb-4", className);
    $[27] = className;
    $[28] = t3;
  } else {
    t3 = $[28];
  }
  let t4;
  if ($[29] !== couponVisualImageUrl || $[30] !== titleText) {
    t4 = <div className="aspect-square w-full flex items-center justify-center overflow-hidden max-w-full">{couponVisualImageUrl ? <Image src={couponVisualImageUrl} alt={titleText} width={260} height={260} className="object-contain w-full h-full" /> : <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400"><span className="text-sm">No Image</span></div>}</div>;
    $[29] = couponVisualImageUrl;
    $[30] = titleText;
    $[31] = t4;
  } else {
    t4 = $[31];
  }
  let t5;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("text-black font-['DINPro-Medium'] font-medium text-center not-italic overflow-hidden text-ellipsis line-clamp-2 box-orient-vertical", "h-10 md:h-11 px-2 md:px-3 text-sm md:text-base leading-4 md:leading-5 mt-2 md:mt-4");
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  let t6;
  if ($[33] !== titleText) {
    t6 = <div className={t5}>{titleText}</div>;
    $[33] = titleText;
    $[34] = t6;
  } else {
    t6 = $[34];
  }
  let t7;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("   leading-none underline text-[#010101]", " text-xs md:text-base ");
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  let t8;
  if ($[36] !== exchange.id || $[37] !== onViewDetail) {
    t8 = () => onViewDetail(exchange.id);
    $[36] = exchange.id;
    $[37] = onViewDetail;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== t) {
    t9 = t("exchange_item.view_details", "View Details");
    $[39] = t;
    $[40] = t9;
  } else {
    t9 = $[40];
  }
  let t10;
  if ($[41] !== t8 || $[42] !== t9) {
    t10 = <button type="button" className={t7} onClick={t8}>{t9}</button>;
    $[41] = t8;
    $[42] = t9;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  const t11 = !pointsNeeded && "invisible";
  let t12;
  if ($[44] !== t11) {
    t12 = cn("font-[DINPro-Medium] font-medium text-center not-italic text-[#aa8052]", "  md:leading-5 mt-2 text-base md:text-xl leading-none", t11);
    $[44] = t11;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== pointsText || $[47] !== t12) {
    t13 = <p className={t12}>{pointsText}</p>;
    $[46] = pointsText;
    $[47] = t12;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== renderExchangeButton) {
    t14 = renderExchangeButton();
    $[49] = renderExchangeButton;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== t10 || $[52] !== t13 || $[53] !== t14 || $[54] !== t3 || $[55] !== t4 || $[56] !== t6) {
    t15 = <div className={t3}>{t4}{t6}{t10}{t13}{t14}</div>;
    $[51] = t10;
    $[52] = t13;
    $[53] = t14;
    $[54] = t3;
    $[55] = t4;
    $[56] = t6;
    $[57] = t15;
  } else {
    t15 = $[57];
  }
  return t15;
};
export default ExchangeItem;
function _temp(reward) {
  return reward.rewardType === "point";
}